// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v_llIIvnYr64X8 {
  box-sizing: border-box;
  width: 248px;
  height: 144px;
  padding: var(--ds-space-100, 8px) var(--ds-space-150, 12px);
  overflow: hidden;
  border: none;
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-background-brand-bold, #0c66e4);
  background-image: none;
  background-repeat: no-repeat;
  background-size: cover;
  color: var(--ds-text, #172b4d);
}
.v_llIIvnYr64X8.jG6xWphe0e10MH {
  background-color: var(--ds-background-neutral, #091e420f);
}
.v_llIIvnYr64X8 .fKXlK8jt6BZxVr,
.v_llIIvnYr64X8 .cv6fLG4aLl7VS1,
.v_llIIvnYr64X8 .ScJMhYRoDfqRks {
  color: inherit;
}
.v_llIIvnYr64X8 .PR6PKD6qe_K4zM {
  opacity: 1;
}
.jG6xWphe0e10MH .PR6PKD6qe_K4zM,
.UX_igUlxRop7wu .PR6PKD6qe_K4zM {
  opacity: 0;
}
.jG6xWphe0e10MH .Tthnq96wrwrX6a,
.UX_igUlxRop7wu .Tthnq96wrwrX6a {
  background-color: var(--ds-background-neutral, #091e420f);
}
.fKXlK8jt6BZxVr {
  margin: var(--ds-space-0, 0);
  overflow: hidden;
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-size: 14px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fKXlK8jt6BZxVr ~ .Ufvs2pOhXMA5cs {
  margin-top: var(--ds-space-200, 16px);
}
.fKXlK8jt6BZxVr ~ .cv6fLG4aLl7VS1 {
  margin-top: var(--ds-space-050, 4px);
}
.Ufvs2pOhXMA5cs {
  white-space: nowrap;
}
.Ufvs2pOhXMA5cs .Tthnq96wrwrX6a {
  display: inline-block;
  margin-right: var(--ds-space-100, 8px);
  vertical-align: top;
}
.Ufvs2pOhXMA5cs .Tthnq96wrwrX6a:last-child {
  margin-right: var(--ds-space-0, 0);
}
.cv6fLG4aLl7VS1 {
  margin: var(--ds-space-0, 0);
  overflow: hidden;
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-size: 12px;
  font-weight: var(--ds-font-weight-regular, normal);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ScJMhYRoDfqRks {
  overflow: visible;
  text-overflow: clip;
  white-space: normal;
}
.PR6PKD6qe_K4zM {
  box-sizing: border-box;
  height: 20px;
  border-radius: var(--ds-border-radius-100, 4px);
  opacity: 0.8;
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: 0px 1px 1px var(--ds-border, #091e4224), 0px 0px 1px var(--ds-border, #091e4224);
}
.Tthnq96wrwrX6a {
  box-sizing: border-box;
  width: calc(20% - 6px);
  padding: var(--ds-space-050, 4px) var(--ds-space-050, 4px) var(--ds-space-200, 16px);
  border-radius: var(--ds-border-radius-200, 6px);
  background-color: var(--ds-surface-sunken, #f7f8f9);
}
.Tthnq96wrwrX6a .PR6PKD6qe_K4zM {
  margin-bottom: var(--ds-space-050, 4px);
}
.Tthnq96wrwrX6a .PR6PKD6qe_K4zM:last-child {
  margin-bottom: var(--ds-space-0, 0);
}
.wnDW5riPMpkt32 {
  display: block;
  width: 112px;
  height: 8px;
  margin-bottom: var(--ds-space-200, 16px);
  border-radius: 100px;
  background-color: var(--ds-surface, #ffffff);
}
`, ""]);
// Exports
export var board = `v_llIIvnYr64X8`;
export var boardError = `jG6xWphe0e10MH`;
export var boardName = `fKXlK8jt6BZxVr`;
export var teamName = `cv6fLG4aLl7VS1`;
export var errorMessage = `ScJMhYRoDfqRks`;
export var card = `PR6PKD6qe_K4zM`;
export var boardLoading = `UX_igUlxRop7wu`;
export var list = `Tthnq96wrwrX6a`;
export var boardLists = `Ufvs2pOhXMA5cs`;
export var placeholderTopBar = `wnDW5riPMpkt32`;
export default ___CSS_LOADER_EXPORT___;
